import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    mensaje: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí puedes agregar la lógica para enviar el formulario
    console.log('Formulario enviado:', formData);
    // Resetear formulario después de enviar
    setFormData({
      nombre: '',
      email: '',
      mensaje: ''
    });
    alert('¡Mensaje enviado con éxito!');
  };

  return (
    <section className="contact-us">
      <div className="container">
        <div className="breadcrumb">
          <Link to="/">INICIO</Link>
          <span> / </span>
          <span>CONTÁCTANOS</span>
        </div>

        <h1 className="contact-us-title">CONTÁCTANOS</h1>

        <div className="contact-us-content">
          {/* Sección del Formulario */}
          <div className="contact-form-section">
            <h2 className="contact-section-title">Déjanos tu mensaje</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Nombre"
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <textarea
                  id="mensaje"
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleChange}
                  placeholder="Mensaje"
                  rows="6"
                  required
                  className="form-textarea"
                ></textarea>
              </div>
              <button type="submit" className="submit-button">
                Enviar
              </button>
            </form>
          </div>

          {/* Sección de Horarios */}
          <div className="contact-info-box">
            <h2 className="contact-section-title">Horarios</h2>
            <div className="info-content">
              <div className="location-info">
                <h3 className="location-title">VALENCIA:</h3>
                <p className="info-text">De Lunes a Domingo:</p>
                <p className="info-text">12:00pm a 10:00pm</p>
              </div>
              <div className="location-info">
                <h3 className="location-title">MARACAY:</h3>
                <p className="info-text">De Lunes a Domingo:</p>
                <p className="info-text">12:00pm a 10:00pm</p>
              </div>
              <div className="location-info">
                <h3 className="location-title">CARACAS-CATIA:</h3>
                <p className="info-text">De Lunes a Domingo:</p>
                <p className="info-text">12:00pm a 10:00pm</p>
              </div>
              <div className="location-info">
                <h3 className="location-title">CARACAS-LA FLORIDA:</h3>
                <p className="info-text">De Lunes a Domingo:</p>
                <p className="info-text">12:00pm a 10:00pm</p>
              </div>
              <div className="location-info">
                <h3 className="location-title">BARQUISIMETO:</h3>
                <p className="info-text">De Lunes a Domingo:</p>
                <p className="info-text">12:00pm a 10:00pm</p>
              </div>
            </div>
          </div>

          {/* Sección de WhatsApp */}
          <div className="contact-info-box">
            <h2 className="contact-section-title">Whatsapp</h2>
            <div className="info-content">
              <div className="location-info">
                <p className="info-text">
                  <a 
                    href="https://wa.me/584126274276" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="whatsapp-link"
                  >
                    0412-6274276
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;

